import {
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import Link from "next/link";

import CloseModalSvg from "@/assets/svg/close-modal.svg";
import { ExternalUrlIcons } from "@/components/ui/buttons/ExternalUrlIcons.server";
import DefaultImage from "@/components/ui/DefaultImage";
import { h_400_12_135_48, h_700_16_100_32 } from "@/styles/fontStyles";
import { addressSelector } from "@/utils/addressSelector";
import { imgSelector } from "@/utils/imgSelector";

import {
  LinkedInWebSiteElement,
  PlainTextInTable,
} from "../AssociatedCompanies/AssociatedCompanies";

export const AssociatedFundsModal = ({ control, data }) => {
  const { isOpen, onClose } = control;

  const renderData = [
    {
      title: "Location",
      value: addressSelector({ data: data?.resFund?.addresses }),
      width: "156px",
    },
    {
      title: "Website",
      value: urlChecker(data?.resFund?.webUrl?.urlWebsite),
      width: "48px",
    },
    {
      title: "LinkedIn",
      value: urlChecker(data?.resFund?.webUrl?.urlLinkedin),
      width: "49px",
    },
    { title: "Title", value: data?.fundStuffTitle, width: "101px" },
    {
      title: "Function",
      value: data?.fundStaffFunction,
      width: "52px",
    },
    {
      title: "Level",
      value: data?.fundStaffLevel,
      width: "auto",
    },
  ];

  const blockSwitcher = ({ item }) => {
    switch (item?.title) {
      case "Website":
        return item?.value ? (
          <LinkedInWebSiteElement {...{ url: item?.value, type: "webSite" }} />
        ) : (
          <PlainTextInTable />
        );

      case "LinkedIn":
        return item?.value ? (
          <LinkedInWebSiteElement {...{ url: item?.value, type: "linkedIn" }} />
        ) : (
          <PlainTextInTable />
        );
      default:
        return (
          <PlainTextInTable
            {...{ data: item?.value, styleText: { color: "mainBlue" } }}
          />
        );
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent w={"327px"} p={"10px 20px 20px 20px"}>
        <ModalBody p={"0px"}>
          <Flex flexDir={"column"} gap={"16px"}>
            <Flex justify={"space-between"} align={"center"}>
              <Flex gap={"8px"} align={"center"}>
                <DefaultImage
                  src={imgSelector({ data: data?.resFund })}
                  options={{
                    borderRadius: "2px",
                    w: "22px",
                  }}
                />
                <Link
                  href={`/investors/funds/${data?.resFund?.slug}`}
                  target="_blank"
                >
                  <Tooltip
                    label={data?.resFund?.nameBrand || ""}
                    placement="top"
                    pt={"4px"}
                  >
                    <Text
                      {...h_700_16_100_32}
                      color={"naturalBlack"}
                      pt={"4px"}
                      w={"85%"}
                      isTruncated
                    >
                      {data?.resFund?.nameBrand}
                    </Text>
                  </Tooltip>
                </Link>
              </Flex>
              <Flex
                align={"center"}
                onClick={() => {
                  onClose();
                }}
                cursor={"pointer"}
              >
                <CloseModalSvg />
              </Flex>
            </Flex>
            <Flex flexWrap={"wrap"} justify={"space-between"} gap={"8px"}>
              {data &&
                renderData?.map((item, index) => {
                  return (
                    <Flex
                      flexDir={"column"}
                      key={`${item?.title}-${index}`}
                      w={item?.width}
                      gap={"4px"}
                    >
                      <Text {...h_400_12_135_48} color={"gray"}>
                        {item?.title}
                      </Text>
                      {blockSwitcher({ item })}
                    </Flex>
                  );
                })}
            </Flex>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
